import { lazy } from 'react'
// import Index from '../pages/index'
const Index = lazy(() => import('../pages/index/index'))
const Company = lazy(() => import('../pages/Company'))
const ProductDetail = lazy(() => import('../pages/ProductDetail'))
const Features = lazy(()=> import('../pages/Features'))
const Partner = lazy(()=> import('../pages/Partner'))
const ProductDetailNew = lazy(()=> import('../pages/ProductDetailNew'))

const route = [
    {
        path: '/',
        key: 'Index',
        element: <Index/>,
    },
    {
        path: '/company',
        key: 'Company',
        element: <Company/>,
    },
    {
        path: '/product/:id',
        key: 'Product',
        element: <ProductDetail/>,
    },
    {
        path: '/productNew/:id',
        key: 'ProductNew',
        element: <ProductDetailNew/>,
    },
    {
        path: '/features',
        key: 'Features',
        element: <Features/>,
    },
    {
        path: '/partner',
        key: 'Partner',
        element: <Partner/>,
    }
]
export default route